import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import queries from '@nc-aftermarket/config/queryDefs';
import Alert from './Alert';
import useUserInfo from '../lib/useUserInfo';

export default function AppStatus() {
  const metaQuery = useQuery(queries.UserInvoicesMeta);
  const { status } = useUserInfo();
  return (
    <div className="tw-wrap">
      {status === 'banned' && (
        <Alert className="tw-mt-4" title="Bidding is currently disabled" />
      )}
      {metaQuery.data?.self.unpaid.total > 0 && (
        <Alert
          className="tw-mt-4"
          severity="info"
          title="You have unpaid domains">
          <p>
            You have unpaid domains that were recently won at auction.{' '}
            <Link to="/dashboard/won/unpaid/">Go to your dashboard</Link> to
            settle up before the offer expires.
          </p>
        </Alert>
      )}
    </div>
  );
}
